'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function BSFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-wa75si1wc", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-wa75si1wc)" }, /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#3cb1cf", d: "M0 0h32v8H0zm0 16h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#272727", d: "M0 0l16 12L0 24z" })))
  );
}

export { BSFlag };
//# sourceMappingURL=BS.mjs.map
